import React, { useState, useEffect } from 'react';
import { Box, Button, Container, Grid, Select, MenuItem, InputLabel, FormControl, FormGroup, FormControlLabel, Checkbox, TextField, Typography, CircularProgress, ListItemText, OutlinedInput } from "@mui/material";
import api from '../service/Api';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSnackbar } from 'notistack';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export default function Formulario() {
    const [formState, setFormState] = useState({
        processo: '',
        areas_selecionadas: [],
        responsavel: [],
        atividade: '',
        finalidade: '',
        descricao: '',
        dados_pessoais_tratados: [],
        dados_sensiveis: false,
        desc_sensiveis: [],
        dados_menor: false,
        desc_dados_menor: [],
        dados_menor_sensiveis: false,
        desc_dados_menor_sensiveis: [],
        colhidos: '',
        colhidos_texto: null,
        armazenados: '',
        armazenados_texto: null,
        armazenados_digital: null,
        armazenamento: '',
        compartilhamento_externo: false,
        compartilhamento_externo_terceirizados: null,
        transferencia_internacional: false,
        transferencia_internacional_text: null,
        cnm: '',
        areas_com_acesso: [],
        bases: [],
        riscos: '',
        classificacao_riscos: '',
        ripd: null,
        acoes: null
    });

    const [mostrarSelectSecundarioSensiveis, setMostrarSelectSecundarioSensiveis] = useState(false);
    const [mostrarSelectSecundarioMenor, setMostrarSelectSecundarioMenor] = useState(false);
    const [mostrarSelectSecundarioMenorSensiveis, setMostrarSelectSecundarioMenorSensiveis] = useState(false);
    const [mostrarTextoOutros, setMostrarTextoOutros] = useState(false);
    const [mostrarLivreArmazenados, setMostrarLivreArmazenados] = useState(false);
    const [mostrarOutros, setMostrarOutros] = useState(false);
    const [mostrarExternos, setMostrarExternos] = useState(false);
    const [mostrarTransf, setMostrarTransf] = useState(false);
    const [loading, setLoading] = useState(false);

    const [areasDeAtuacao, setAreasDeAtuacao] = useState([]);
    const [responsaveis, setResponsaveis] = useState([]);
    const [pagina, setPagina] = useState(1);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        const fetchAreasDeAtuacao = async () => {
            try {
                const responseAreas = await api.get('api/areas');
                const responseResp = await api.get('api/responsaveis');
                setAreasDeAtuacao(responseAreas.data);
                setResponsaveis(responseResp.data);
            } catch (error) {
                console.error('Erro ao buscar dados:', error);
            }
        };

        fetchAreasDeAtuacao();
    }, []);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        if (type === 'checkbox') {
            if (name === 'bases') {
                setFormState(prevState => {
                    const newBases = checked
                        ? [...prevState.bases, value]
                        : prevState.bases.filter(base => base !== value);
                    return { ...prevState, bases: newBases };
                });
            } else {
                setFormState(prevState => ({
                    ...prevState,
                    [name]: checked
                }));
            }
        } else {
            setFormState(prevState => ({
                ...prevState,
                [name]: value === '' ? null : value
            }));
        }

        if (name === 'dados_sensiveis') {
            setMostrarSelectSecundarioSensiveis(value);
        }
        if (name === 'dados_menor') {
            setMostrarSelectSecundarioMenor(value);
        }
        if (name === 'dados_menor_sensiveis') {
            setMostrarSelectSecundarioMenorSensiveis(value);
        }
        if (name === 'colhidos') {
            setMostrarTextoOutros(value === 'Outro');
        }
        if (name === 'armazenados') {
            setMostrarLivreArmazenados(value === 'Físico');
            setMostrarOutros(value === 'Digital' || value === 'Ambos');
        }
        if (name === 'compartilhamento_externo') {
            setMostrarExternos(value);
        }
        if (name === 'transferencia_internacional') {
            setMostrarTransf(value);
        }
    };

    const handleAreaChange = async (selectedAreas) => {
        setFormState(prevState => ({
            ...prevState,
            areas_selecionadas: selectedAreas
        }));

        try {
            const responseRep = await api.get('api/responsaveis');
            let responsaveisFiltrados = responseRep.data;
            if (selectedAreas.length > 0) {
                responsaveisFiltrados = responsaveisFiltrados.filter(responsavel => selectedAreas.includes(responsavel.area_de_atuacao_id));
            }
            setResponsaveis(responsaveisFiltrados);
        } catch (error) {
            console.error('Erro ao filtrar responsáveis: ', error);
        }
    };

    const handleProximaPagina = () => {
        setPagina(2);
    };

    const handleVoltaPagina = () => {
        setPagina(1);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!formState.processo || !formState.areas_selecionadas.length) {
            enqueueSnackbar('Preencha os campos corretamente', { variant: 'warning', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            return;
        }

        setLoading(true);

        try {
            await api.post('api/create', formState);
            enqueueSnackbar('Processo gravado com sucesso!', { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            setTimeout(() => {
                window.location.replace("/home");
            }, 3000);

        } catch (error) {
            if (error.response && error.response.data) {
                console.error('Erro ao gravar o processo:', error.response.data);
                enqueueSnackbar('Erro ao gravar processo!', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            } else {
                console.error('Erro ao gravar o processo:', error);
                enqueueSnackbar('Erro ao gravar processo!', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="md">
            <Box sx={{ mt: 4 }}>
                {pagina === 1 ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Processo"
                                    name="processo"
                                    value={formState.processo}
                                    onChange={handleChange}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel id="select-areasDeAtuacao-label">Áreas de Atuação</InputLabel>
                                <Select
                                    labelId="select-areasDeAtuacao-label"
                                    multiple
                                    name="areas_selecionadas"
                                    value={formState.areas_selecionadas}
                                    onChange={(e) => handleAreaChange(e.target.value)}
                                    renderValue={(selected) =>
                                        selected.map((id) => areasDeAtuacao.find((area) => area.id === id)?.nome).join(', ')
                                    }
                                    input={<OutlinedInput label="Áreas de Atuação" />}
                                    MenuProps={MenuProps}
                                >
                                    {areasDeAtuacao.map((area) => (
                                        <MenuItem key={area.id} value={area.id}>
                                            <Checkbox checked={formState.areas_selecionadas.indexOf(area.id) > -1} />
                                            <ListItemText primary={area.nome} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel id="select-responsaveis-label">* Responsável pelo tratamento</InputLabel>
                                <Select
                                    labelId="select-responsaveis-label"
                                    name="responsavel"
                                    multiple
                                    value={formState.responsavel}
                                    onChange={handleChange}
                                    renderValue={(selected) =>
                                        selected.map((id) => responsaveis.find((responsavel) => responsavel.id === id)?.nome).join(', ')
                                    }
                                    input={<OutlinedInput label="* Responsável pelo tratamento" />}
                                    required
                                    MenuProps={MenuProps}
                                >
                                    {responsaveis.map((responsavel) => (
                                        <MenuItem key={responsavel.id} value={responsavel.id}>
                                            <Checkbox checked={formState.responsavel.indexOf(responsavel.id) > -1} />
                                            <ListItemText primary={responsavel.nome} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Atividade de tratamento de dados pessoais"
                                    name="atividade"
                                    value={formState.atividade}
                                    onChange={handleChange}
                                    multiline
                                    rows={3}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Finalidade"
                                    name="finalidade"
                                    value={formState.finalidade}
                                    onChange={handleChange}
                                    multiline
                                    rows={3}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Descreva o Processo"
                                    name="descricao"
                                    value={formState.descricao}
                                    onChange={handleChange}
                                    multiline
                                    rows={4}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth >
                                <InputLabel id="select-dadosPessoaisTratados-label">Dados Pessoais Tratados</InputLabel>
                                <Select
                                    labelId="select-dadosPessoaisTratados-label"
                                    name="dados_pessoais_tratados"
                                    value={formState.dados_pessoais_tratados}
                                    onChange={handleChange}
                                    multiple
                                    renderValue={(selected) => selected.join(', ')}
                                    input={<OutlinedInput label="Dados Pessoais Tratados" />}
                                    MenuProps={MenuProps}
                                >
                                    {[
                                        "Nome", "Cargo", "Dados Bancários", "CPF", "RG",
                                        "Município", "UF", "Data de Nascimento", "Sexo", "Estado Civil", "Profissão",
                                        "Escolaridade", "Endereço Residencial", "Celular", "Telefone", "E-mail", "Salário",
                                        "Matrícula", "Nome de dependentes", "Certidão de casamento", "Reservista", "CTPS",
                                        "PIS", "Filiação", "Naturalidade", "Nome de cônjuge", "Título de eleitor", "Partido Político"
                                    ].map((item) => (
                                        <MenuItem key={item} value={item}>
                                            <Checkbox checked={formState.dados_pessoais_tratados.indexOf(item) > -1} />
                                            <ListItemText primary={item} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Grid>
                        <Grid item xs={6}>
                            <Grid>
                                <FormControl fullWidth>
                                    <InputLabel id="select-dadosSensiveis-label">Dados Sensíveis?</InputLabel>
                                    <Select
                                        name="dados_sensiveis"
                                        value={formState.dados_sensiveis}
                                        onChange={handleChange}
                                        labelId="select-dadosSensiveis-label"
                                    >
                                        <MenuItem value={true}>Sim</MenuItem>
                                        <MenuItem value={false}>Não</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {mostrarSelectSecundarioSensiveis && (
                                <Grid>
                                    <FormControl fullWidth>
                                        <InputLabel id="select-quaisDadosSensiveis-label">Quais?</InputLabel>
                                        <Select
                                            labelId="select-quaisDadosSensiveis-label"
                                            name="desc_sensiveis"
                                            value={formState.desc_sensiveis}
                                            onChange={handleChange}
                                            multiple
                                            renderValue={(selected) => selected.join(', ')}
                                            input={<OutlinedInput label="Quais?" />}
                                            MenuProps={MenuProps}
                                        >
                                            {[
                                                "Cartão de vacina", "Origem Racial ou Étnica", "Religião", "Opinião Política",
                                                "Filiação a Sindicato", "Dados de Saúde/Vida Sexual", "Dados Genéticos/Biométricos",
                                                "Imagem", "Gênero"
                                            ].map((item) => (
                                                <MenuItem key={item} value={item}>
                                                    <Checkbox checked={formState.desc_sensiveis.indexOf(item) > -1} />
                                                    <ListItemText primary={item} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}
                        </Grid>
                        <Grid item xs={6}>
                            <Grid>
                                <FormControl fullWidth>
                                    <InputLabel id="select-dadosMenor-label">* Dados de menores de idade?</InputLabel>
                                    <Select
                                        name="dados_menor"
                                        value={formState.dados_menor}
                                        onChange={handleChange}
                                        labelId="select-dadosMenor-label"
                                    >
                                        <MenuItem value={true}>Sim</MenuItem>
                                        <MenuItem value={false}>Não</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {mostrarSelectSecundarioMenor && (
                                <Grid>
                                    <FormControl fullWidth>
                                        <InputLabel id="select-quaisDadosMenor-label">Quais?</InputLabel>
                                        <Select
                                            labelId="select-quaisDadosMenor-label"
                                            name="desc_dados_menor"
                                            value={formState.desc_dados_menor}
                                            onChange={handleChange}
                                            multiple
                                            renderValue={(selected) => selected.join(', ')}
                                            input={<OutlinedInput label="Quais?" />}
                                            MenuProps={MenuProps}
                                        >
                                            {[
                                                "Nome", "Cartão de vacinas", "CPF", "RG", "Data de Nascimento", "Sexo", "Estado Civil",
                                                "Profissão", "Escolaridade", "Endereço Residencial", "Telefone"
                                            ].map((item) => (
                                                <MenuItem key={item} value={item}>
                                                    <Checkbox checked={formState.desc_dados_menor.indexOf(item) > -1} />
                                                    <ListItemText primary={item} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}
                        </Grid>
                        <Grid item xs={6}>
                            <Grid>
                                <FormControl fullWidth>
                                    <InputLabel id="select-dadosMenorSensiveis-label">* Dados sensíveis de menores de idade?</InputLabel>
                                    <Select
                                        name="dados_menor_sensiveis"
                                        value={formState.dados_menor_sensiveis}
                                        onChange={handleChange}
                                        labelId="select-dadosMenorSensiveis-label"
                                    >
                                        <MenuItem value={true}>Sim</MenuItem>
                                        <MenuItem value={false}>Não</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {mostrarSelectSecundarioMenorSensiveis && (
                                <Grid>
                                    <FormControl fullWidth>
                                        <InputLabel id="select-quaisDadosMenorSensiveis-label">Quais?</InputLabel>
                                        <Select
                                            labelId="select-quaisDadosMenorSensiveis-label"
                                            name="desc_dados_menor_sensiveis"
                                            value={formState.desc_dados_menor_sensiveis}
                                            onChange={handleChange}
                                            multiple
                                            renderValue={(selected) => selected.join(', ')}
                                            input={<OutlinedInput label="Quais?" />}
                                            MenuProps={MenuProps}
                                        >
                                            {[
                                                "Origem Racial ou Étnica", "Religião", "Opinião Política", "Filiação a Sindicato",
                                                "Dados de Saúde/Vida Sexual", "Dados Genéticos/Biométricos", "Imagem", "Gênero"
                                            ].map((item) => (
                                                <MenuItem key={item} value={item}>
                                                    <Checkbox checked={formState.desc_dados_menor_sensiveis.indexOf(item) > -1} />
                                                    <ListItemText primary={item} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}
                        </Grid>
                        <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', alignItems: 'center' }}>
                            <ArrowForwardIcon sx={{ fontSize: '5rem', color: 'rgba(0, 90, 156)' }} onClick={handleProximaPagina} />
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel id="select-colhidos-label">* Como foram colhidos os dados?</InputLabel>
                                <Select
                                    labelId="select-colhidos-label"
                                    name="colhidos"
                                    value={formState.colhidos}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="Titular">Titular</MenuItem>
                                    <MenuItem value="Outro">Outro</MenuItem>
                                </Select>
                            </FormControl>
                            {mostrarTextoOutros && (
                                <FormControl fullWidth margin="normal">
                                    <TextField
                                        label="Como dados foram colhidos?"
                                        name="colhidos_texto"
                                        value={formState.colhidos_texto}
                                        onChange={handleChange}
                                        multiline
                                        rows={3}
                                    />
                                </FormControl>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel id="select-armazenados-label">* Onde os dados estão armazenados?</InputLabel>
                                <Select
                                    labelId="select-armazenados-label"
                                    name="armazenados"
                                    value={formState.armazenados}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="Físico">Físico</MenuItem>
                                    <MenuItem value="Digital">Digital</MenuItem>
                                    <MenuItem value="Ambos">Ambos</MenuItem>
                                </Select>
                            </FormControl>
                            {mostrarLivreArmazenados && (
                                <FormControl fullWidth margin="normal">
                                    <TextField
                                        label="Onde estão armazenados os dados?"
                                        name="armazenados_texto"
                                        value={formState.armazenados_texto}
                                        onChange={handleChange}
                                        multiline
                                        rows={3}
                                    />
                                </FormControl>
                            )}
                            {mostrarOutros && (
                                <FormControl fullWidth margin="normal">
                                    <TextField
                                        label="Onde estão armazenados os dados?"
                                        name="armazenados_digital"
                                        value={formState.armazenados_digital}
                                        onChange={handleChange}
                                        multiline
                                        rows={3}
                                    />
                                </FormControl>
                            )}
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth>
                                <TextField
                                    name="armazenamento"
                                    label="Tempo de Armazenamento"
                                    onChange={handleChange}
                                    value={formState.armazenamento}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth>
                                <InputLabel id="select-compartilhamento-ext-label">* Compartilhamento externo</InputLabel>
                                <Select
                                    labelId="select-compartilhamento-ext-label"
                                    name="compartilhamento_externo"
                                    value={formState.compartilhamento_externo}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={true}>Sim</MenuItem>
                                    <MenuItem value={false}>Não</MenuItem>
                                </Select>
                            </FormControl>
                            {mostrarExternos && (
                                <FormControl fullWidth margin='normal'>
                                    <TextField
                                        label="Terceirizados"
                                        name="compartilhamento_externo_terceirizados"
                                        value={formState.compartilhamento_externo_terceirizados}
                                        onChange={handleChange}
                                    />
                                </FormControl>
                            )}
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth>
                                <InputLabel id="select-transferencia-internacional-label">* Transferência internacional de dados</InputLabel>
                                <Select
                                    labelId="select-transferencia-internacional-label"
                                    name="transferencia_internacional"
                                    value={formState.transferencia_internacional}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={true}>Sim</MenuItem>
                                    <MenuItem value={false}>Não</MenuItem>
                                </Select>
                            </FormControl>
                            {mostrarTransf && (
                                <FormControl fullWidth margin='normal'>
                                    <TextField
                                        label="Detalhes da transferência internacional"
                                        name="transferencia_internacional_text"
                                        value={formState.transferencia_internacional_text}
                                        onChange={handleChange}
                                        multiline
                                        rows={2}
                                    />
                                </FormControl>
                            )}
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel id="select-cnm">* CNM</InputLabel>
                                <Select
                                    labelId="select-cnm"
                                    name="cnm"
                                    value={formState.cnm}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Controlador">Controlador</MenuItem>
                                    <MenuItem value="Operador">Operador</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel id="select-areas-com-acesso-label">* Áreas que acessam a esses dados</InputLabel>
                                <Select
                                    labelId="select-areas-com-acesso-label"
                                    multiple
                                    name="areas_com_acesso"
                                    value={formState.areas_com_acesso}
                                    onChange={handleChange}
                                    renderValue={(selected) =>
                                        selected.map((id) => areasDeAtuacao.find((area) => area.id === id)?.nome).join(', ')
                                    }
                                    input={<OutlinedInput label="* Áreas que acessam a esses dados" />}
                                    MenuProps={MenuProps}
                                >
                                    {areasDeAtuacao.map((area) => (
                                        <MenuItem key={area.id} value={area.id}>
                                            <Checkbox checked={formState.areas_com_acesso.indexOf(area.id) > -1} />
                                            <ListItemText primary={area.nome} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <Typography variant="h6" gutterBottom>
                                    * Bases legais de tratamento
                                </Typography>
                                <FormGroup>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Consentimento do titular" />}
                                                label="Consentimento do titular"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Cumprimento de obrigação legal ou regulatória" />}
                                                label="Cumprimento de obrigação legal ou regulatória"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Execução de contrato" />}
                                                label="Execução de contrato"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Exercício regular de direitos em processo judicial, administrativo ou arbitral" />}
                                                label="Exercício regular de direitos em processo judicial, administrativo ou arbitral"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Tutela da saúde" />}
                                                label="Tutela da saúde"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Contrato Trabalhista" />}
                                                label="Contrato Trabalhista"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Legítimo interesse" />}
                                                label="Legítimo interesse"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Pela administração pública, para execução de políticas públicas" />}
                                                label="Pela administração pública, para execução de políticas públicas"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Realização de estudos por órgão de pesquisa" />}
                                                label="Realização de estudos por órgão de pesquisa"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Proteção da vida ou da incolumidade física do titular ou de terceiro" />}
                                                label="Proteção da vida ou da incolumidade física do titular ou de terceiro"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Proteção do crédito" />}
                                                label="Proteção do crédito"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Sem base legal" />}
                                                label="Sem base legal"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox onChange={handleChange} name="bases" value="Obrigação contratual" />}
                                                label="Obrigação contratual"
                                            />
                                        </Grid>
                                    </Grid>
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel id="riscos-label">* Risco de vazamento</InputLabel>
                                <Select
                                    labelId="riscos-label"
                                    name="riscos"
                                    value={formState.riscos}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Alto">Alto</MenuItem>
                                    <MenuItem value="Medio">Médio</MenuItem>
                                    <MenuItem value="Baixo">Baixo</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel id="classificacao-riscos-label">* Classificação de risco</InputLabel>
                                <Select
                                    labelId="classificacao-riscos-label"
                                    name="classificacao_riscos"
                                    value={formState.classificacao_riscos}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Alto">Alto</MenuItem>
                                    <MenuItem value="Medio">Médio</MenuItem>
                                    <MenuItem value="Baixo">Baixo</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    label="RIPD"
                                    name="ripd"
                                    value={formState.ripd}
                                    onChange={handleChange}
                                    multiline
                                    rows={3}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Ações"
                                    name="acoes"
                                    value={formState.acoes}
                                    onChange={handleChange}
                                    multiline
                                    rows={3}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
                            <ArrowBackIcon sx={{ fontSize: '5rem', color: 'rgba(0, 90, 156)' }} onClick={handleVoltaPagina} />
                        </Grid>
                        <Grid item xs={12} sx={{ mb: 4 }}>
                            <Button fullWidth variant="contained" type="submit" onClick={handleSubmit} disabled={loading}>
                                {loading ? <CircularProgress size={24} /> : 'Gravar Processo'}
                            </Button>
                        </Grid>
                    </Grid>
                )}
            </Box>
        </Container>
    );
}
